<template>
    <section>
        <div class="row">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'employee/index' }">
                                Pegawai BTA
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            Create New Pegawai BTA
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <form v-on:submit.prevent="save">
                    	<template v-if="profile.isAdmin">
                        <div class="row mb-1">
                            <div class="col">
                                <label class="h3 font-weight-medium mb-0 required d-block">Jabatan</label>
                                <div class="form-check form-check-inline py-1 pl-0" v-for="role in roles">
                                    <div class="custom-control custom-checkbox">
                                        <input v-model="form.employee.roles" type="checkbox" v-bind:value="role.id" class="custom-control-input" v-bind:id="'input-position-' + role.id" />
                                        <label class="custom-control-label" v-bind:for="'input-position-' + role.id">{{ role.name }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
			</template>
                        <div class="alert alert-light" role="alert" v-if="Object.values(additionalForm).filter(hasRole => hasRole).length">
                            <div class="row mb-2" v-if="additionalForm.hasBranchOption">
                                <div class="col">
                                    <label class="font-weight-medium mb-0 h3 required d-block">Cabang</label>
                                    <div class="form-check form-check-inline py-1 pl-0" v-for="branch in branches">
                                        <div class="custom-control custom-radio">
                                            <input v-model="form.employee.branchID" type="radio" v-bind:value="branch.id" class="custom-control-input" v-bind:id="'input-branch-' + branch.id" />
                                            <label class="custom-control-label" v-bind:for="'input-branch-' + branch.id">{{ branch.name }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-2" v-if="additionalForm.hasSubjectOption">
                                <div class="col">
                                    <label class="font-weight-medium mb-0 h3 required d-block">Mata Pelajaran Korbid</label>
                                    <div class="form-check form-check-inline py-1 pl-0" v-for="subject in subjects">
                                        <div class="custom-control custom-radio">
                                            <input v-model="form.employee.subjectID" type="radio" v-bind:value="subject.id" class="custom-control-input" v-bind:id="'input-subject-id-' + subject.id" />
                                            <label class="custom-control-label" v-bind:for="'input-subject-id-' + subject.id">{{ subject.name }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-2" v-if="additionalForm.hasSubjectsOption">
                                <div class="col">
                                    <label class="font-weight-medium mb-0 h3 required d-block">Mata Pelajaran Pengajar</label>
                                    <div class="form-check form-check-inline py-1 pl-0" v-for="subject in subjects">
                                        <div class="custom-control custom-checkbox">
                                            <input v-model="form.employee.subjectIDs" type="checkbox" v-bind:value="subject.id" class="custom-control-input" v-bind:id="'input-subject-ids-' + subject.id" />
                                            <label class="custom-control-label" v-bind:for="'input-subject-ids-' + subject.id">{{ subject.name }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    
                    <div class="row mt-2">
                        <div class="col-md-4 col-sm-12">
                            <!-- Section 1 -->
                            <div class="card shadow-sm mb-4 border-0">
                                <div class="card-header background-primary">
                                    <div class="row">
                                        <div class="col">
                                            <span class="h4 font-weight-medium text-white mb-0">
                                                Profil Pegawai
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row mb-3 align-items-center">
                                        <div class="col-12">
                                            <div v-bind:style="'background-image: url(' + imagePreview +')'" class="user-avatar rounded-circle">
                                                <div class="overlay rounded-circle text-center text-white" v-on:click="$refs.upload.click()">
                                                    <i class="fa fa-upload"></i>
                                                </div>
                                                <input ref="upload" type="file" class="form-control" v-on:change="preview" accept="image/*" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Nama Lengkap</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.employee.name" class="form-control form-control-sm" required/>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Nama Panggilan</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.employee.shortname" class="form-control form-control-sm" required/>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Inisial</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.employee.initial" class="form-control form-control-sm" required/>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center" v-for="attribute in ['tempat_lahir']">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile[attribute]" class="form-control form-control-sm" />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Tanggal Lahir</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <datepicker v-model="form.profile.tanggal_lahir" v-bind:language="dateLanguage" full-month-name monday-first clear-button v-bind:disabled-dates="{from: new Date}" input-class="form-control form-control-sm"></datepicker>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider required">Jenis Kelamin</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <div class="form-check form-check-inline py-1" v-for="gender in ['Laki-laki', 'Perempuan']">
                                                <div class="custom-control custom-radio">
                                                    <input v-model="form.profile.jenis_kelamin" type="radio" class="custom-control-input" v-bind:value="gender" v-bind:id="'input-jenis_kelamin-' + gender" />
                                                    <label class="custom-control-label h4" v-bind:for="'input-jenis_kelamin-' + gender">{{ gender }}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center" v-for="attribute in ['agama', 'status_pernikahan']">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile[attribute]" class="form-control form-control-sm" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4 col-sm-12">
                            <!-- Section 2 -->
                            <div class="card shadow-sm mb-4 border-0">
                                <div class="card-header background-primary">
                                    <div class="row">
                                        <div class="col">
                                            <span class="h4 font-weight-medium text-white mb-0">
                                                Kontak Pegawai
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row mb-1 align-items-center" v-for="attribute in ['alamat', 'rt_rw', 'kel_kec_kota', 'kode_pos', 'telp_rumah']">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile[attribute]" class="form-control form-control-sm" />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider required">No. HP</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.employee.phone" class="form-control form-control-sm" required/>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Alamat Email</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.employee.email" type="email" class="form-control form-control-sm"/>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center" v-for="attribute in ['alumnus_bta', 'joined_at_bta']">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile[attribute]" class="form-control form-control-sm" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4 col-sm-12">
                            <!-- Section 3 -->
                            <div class="card shadow-sm mb-4 border-0">
                                <div class="card-header background-primary">
                                    <div class="row">
                                        <div class="col">
                                            <span class="h4 font-weight-medium text-white mb-0">
                                                Histori Pendidikan
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row mb-1 align-items-center" v-for="attribute in ['asal_sd', 'lulus_sd', 'asal_smp', 'lulus_smp', 'asal_sma', 'lulus_sma', 'asal_univ', 'fakultas_univ', 'jurusan_univ', 'lulus_univ']">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile[attribute]" class="form-control form-control-sm" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4 col-sm-12">
                            <!-- Section 4 -->
                            <div class="card shadow-sm mb-4 border-0">
                                <div class="card-header background-primary">
                                    <div class="row">
                                        <div class="col">
                                            <span class="h4 font-weight-medium text-white mb-0">
                                                Data Keluarga Pegawai
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row mb-1 align-items-center" v-for="attribute in ['nama_pasangan', 'tempat_lahir_pasangan']">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile[attribute]" class="form-control form-control-sm" />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">Tanggal Lahir Pasangan</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <datepicker v-model="form.profile.tanggal_lahir_pasangan" v-bind:language="dateLanguage" full-month-name monday-first clear-button v-bind:disabled-dates="{from: new Date}" input-class="form-control form-control-sm"></datepicker>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center" v-for="attribute in ['jumlah_anak']">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile[attribute]" class="form-control form-control-sm" />
                                        </div>
                                    </div>
                                    <template v-for="n in 5">
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">Nama Anak {{ n }}</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <input v-model="form.profile['nama_anak_' + n]" class="form-control form-control-sm" />
                                            </div>
                                        </div>
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">Tempat Lahir Anak {{ n }}</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <input v-model="form.profile['tempat_lahir_anak_' + n]" class="form-control form-control-sm" />
                                            </div>
                                        </div>
                                        <div class="row mb-1 align-items-center">
                                            <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                                <label class="font-weight-medium text-muted mb-0 h4 form-divider">Tanggal Lahir Anak {{ n }}</label>
                                            </div>
                                            <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                                <datepicker v-model="form.profile['tanggal_lahir_anak_' + n]" v-bind:language="dateLanguage" full-month-name monday-first clear-button v-bind:disabled-dates="{from: new Date}" input-class="form-control form-control-sm"></datepicker>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4 col-sm-12">
                            <!-- Section 5 -->
                            <div class="card shadow-sm mb-4 border-0">
                                <div class="card-header background-primary">
                                    <div class="row">
                                        <div class="col">
                                            <span class="h4 font-weight-medium text-white mb-0">
                                                Data Kepegawaian
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div class="row mb-1 align-items-center" v-for="attribute in ['golongan', 'nomor_ktp']">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile[attribute]" class="form-control form-control-sm" />
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider required">NIP</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.employee.identity" class="form-control form-control-sm" required/>
                                        </div>
                                    </div>
                                    <div class="row mb-1 align-items-center" v-for="attribute in ['nomor_npwp', 'nomor_rekening', 'bank_rekening', 'nama_rekening']">
                                        <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                            <label class="font-weight-medium text-muted mb-0 h4 form-divider">{{ humanize(attribute) }}</label>
                                        </div>
                                        <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                            <input v-model="form.profile[attribute]" class="form-control form-control-sm" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <h4 class="font-weight-bold text-danger">*Wajib Diisi</h4>
                    <div class="pt-3 mb-5">
                        <button type="submit" class="btn btn-danger btn-sm px-5">
                            Save
                        </button>
                        <router-link v-bind:to="{ name: 'employee/index' }" exact class="btn btn-outline-danger btn-sm px-5 ml-3">
                            Cancel
                        </router-link>
                    </div>
                </form>
            </div>
        </div>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import Datepicker from 'vuejs-datepicker';
    import { id } from 'vuejs-datepicker/dist/locale';
    import { employeeRoles, ROLE_EMPLOYEE_BRANCH_STAFF, ROLE_EMPLOYEE_TEACHER, ROLE_EMPLOYEE_COORDINATOR, ROLE_EMPLOYEE_MENTOR, ROLE_EMPLOYEE_BRANCH_HEAD } from '@/params.js';

    export default {
        name: "EmployeeAdd",
        components: {
            Datepicker
        },
        computed: mapState([
            'profile'
        ]),
        data() {
            return {
                form: {
                    employee: {
                        name: '', identity: '', email: '', shortname: '', initial: '', phone: '', image: '', branchID: '', subjectID: '', roles: [], subjectIDs: []
                    },
                    profile: {
                        golongan: '', nomor_npwp: '', nomor_ktp: '', jenis_kelamin: 'Laki-laki', tempat_lahir: '', tanggal_lahir: '', agama: '',
                        bank_rekening: '', nomor_rekening: '', nama_rekening: '',
                        alamat: '', rt_rw: '', kel_kec_kota: '', kode_pos: '', telp_rumah: '',
                        asal_sd: '', lulus_sd: '', asal_smp: '', lulus_smp: '', asal_sma: '', lulus_sma: '', asal_univ: '', fakultas_univ: '', jurusan_univ: '', lulus_univ: '',
                        alumnus_bta: '', joined_at_bta: '',
                        status_pernikahan: '', nama_pasangan: '', tempat_lahir_pasangan: '', tanggal_lahir_pasangan: '', jumlah_anak: '',
                        nama_anak_1: '', tempat_lahir_anak_1: '', tanggal_lahir_anak_1: '',
                        nama_anak_2: '', tempat_lahir_anak_2: '', tanggal_lahir_anak_2: '',
                        nama_anak_3: '', tempat_lahir_anak_3: '', tanggal_lahir_anak_3: '',
                        nama_anak_4: '', tempat_lahir_anak_4: '', tanggal_lahir_anak_4: '',
                        nama_anak_5: '', tempat_lahir_anak_5: '', tanggal_lahir_anak_5: ''
                    }
                },
                imagePreview: '',
                branches: [],
                subjects: [],
                roles: [],
                dateLanguage: id,
                additionalForm: {
                    hasBranchOption: false,
                    hasSubjectOption: false,
                    hasSubjectsOption: false
                }
            };
        },
        watch: {
            'form.employee.roles': {
                handler(newRoles) {
                    this.additionalForm.hasBranchOption = [ROLE_EMPLOYEE_BRANCH_STAFF, ROLE_EMPLOYEE_MENTOR, ROLE_EMPLOYEE_BRANCH_HEAD].some(role => newRoles.includes(role));
                    this.additionalForm.hasSubjectsOption = newRoles.includes(ROLE_EMPLOYEE_TEACHER);
                    this.additionalForm.hasSubjectOption = newRoles.includes(ROLE_EMPLOYEE_COORDINATOR);
                },
                deep: true
            },
            profile() {
                this.setForm();
            }
        },
        methods: {
            save() {
                var formData = new FormData();
                for (var group in this.form) {
                    for (var attribute in this.form[group]) {
                        var value = this.form[group][attribute];
                        if (value instanceof Date) {
                            formData.set(group + '[' + attribute + ']', this.$moment(value).format('YYYY-MM-DD'));
                        } else if (Array.isArray(value)) {
                            for (var i = 0; i < value.length; i++) {
                                formData.append(group + '[' + attribute + '][]', value[i]);
                            }
                        } else {
                            formData.set(group + '[' + attribute + ']', value);
                        }
                    }
                }
                this.axios.post(process.env.API_URL + '/employee', formData).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.$router.push({name: 'employee/view', params: {id: response.data.data.id}});
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            preview(event) {
                var input = event.currentTarget;
                if (input.files && input.files[0]) {
                    this.form.employee.image = input.files[0];
                    var reader = new FileReader();
                    reader.onload = function (event) {
                        this.imagePreview = event.target.result;
                    }.bind(this);
                    reader.readAsDataURL(input.files[0]);
                }
            },
            humanize(string) {
                return string.replace(/[_]+/g, ' ').replace(/^[a-z]| [a-z]/g, function (character) {
                    return character.toUpperCase();
                });
            },
            setForm() {
                if (this.profile.isEmployee) {
                    if (this.profile.employee.isCoordinator) {
                        this.form.employee.roles.push(ROLE_EMPLOYEE_TEACHER);
                        this.form.employee.subjectIDs.push(this.profile.employee.coordinator.subjectID);
                    }
		   if (this.profile.employee.isBranchStaff) {
                        this.form.employee.roles.push(ROLE_EMPLOYEE_MENTOR);
                        this.form.employee.branchIDs.push(this.profile.employee.branchStaff.branchID);
                    }
                }
            }
        },
        created() {
            this.axios.all([
                this.axios.get(process.env.API_URL + '/branch'),
                this.axios.get(process.env.API_URL + '/subject')
            ]).then(this.axios.spread(function (responseBranch, responseSubject) {
                this.branches = responseBranch.data.data;
                this.subjects = responseSubject.data.data;

                this.setForm();
            }.bind(this)));

            this.roles = employeeRoles;
        },
        mounted() {
            document.title = 'Add Employee - ' + process.env.APP_NAME;
        }
    };
</script>

<style scoped>
    img:not([src]), img[src=""]{ display: none; }
    .card-body { padding-left: 1.9rem; padding-right: 1.9rem; }
    @media (max-width: 991.98px) {
        .form-divider::before{ display: none; }
    }
    @media (hover: none) {
        .user-avatar .overlay{ display: block; }
    }
</style>


// WEBPACK FOOTER //
// src/components/employee/Add.vue